import React, { useState, useRef, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Grid,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  MenuItem,
  FormControl,
  Select,
  makeStyles,
  Box,
  CircularProgress,
  Radio,
  IconButton,
} from '@material-ui/core';
import axios from 'axios';
import { appUrl } from '../../../../../../utils/config';
import CloseIcon from '@material-ui/icons/Close';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import WarningIcon from '@material-ui/icons/Warning';
import DeleteIcon from '@material-ui/icons/Delete';
import jwt_decode from 'jwt-decode';
import html2canvas from 'html2canvas';
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    fontWeight: 700,
    fontSize: '22px',
    marginBottom: '1.5rem',
    textAlign: 'center',
    color: '#000',
  },
  closeButton: {
    fontSize: '1rem',
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    color: '#FF0000',
  },
  tableContainer: {
    boxShadow: "none", // Remove border and shadow from the container
    
  },
  table: {
    minWidth: 650,
  },
  tableCell: {
    textAlign: "left",
    backgroundColor: "#E5F2F7",
    borderBottom: "none", // Remove bottom border
    padding: "16px", // Standard padding for consistency
  },
  tableCell2: {
    textAlign: "left",
    backgroundColor: "#E5F2F7",
    borderBottom: "none", // Remove bottom border
    padding: "16px", // Standard padding for consistency
    paddingTop: "0px",
  },
  headerCell: {
    fontWeight: "bold",
  },
  formContainer: {
    marginTop: '24px',
    backgroundColor: '#fff',
  },
  submitButton: {
    backgroundColor: '#ec6535',
    color: '#fff',
    borderRadius: '20px',
    textTransform: 'none',
    padding: '8px 32px',
    '&:hover': {
      backgroundColor: '#d4572e',
    },
  },
  selectField: {
    minWidth: 110,
    maxWidth: 110,
    '& .MuiOutlinedInput-root': {
      height: '32px', // Reduce height
      '& .MuiOutlinedInput-input': {
        padding: '6px 14px', // Reduce padding
      },
    },
  },
  successDialog: {
    textAlign: 'center',
    padding: '40px 20px',
  },
  errorDialog: {
    // textAlign: 'center',
    padding: '40px 30px',
  },
  successIcon: {
    fontSize: '80px',
    color: '#39811D',
    marginBottom: '20px',
  },
  errorIcon: {
    fontSize: '80px',
    color: '#f44336',
    marginBottom: '20px',
  },
  successTitle: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#333',
    marginBottom: '16px',
  },
  errorTitle: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#333',
    marginBottom: '16px',
  },
  successMessage: {
    fontSize: '16px',
    color: '#666',
    marginBottom: '8px',
  },
  errorMessage: {
    fontSize: '16px',
    // color: '#f44336',
    marginBottom: '8px',
  },
  clickHereLink: {
    color: '#1976d2',
    textDecoration: 'underline',
    cursor: 'pointer',
    '&:hover': {
      color: '#115293',
    },
  },
  okButton: {
    backgroundColor: '#ec6535',
    color: '#fff',
    borderRadius: '20px',
    textTransform: 'none',
    padding: '8px 24px',
    marginTop: '20px',
    '&:hover': {
      backgroundColor: '#d4572e',
    },
  },
  aslTableContainer: {
    marginTop: '24px',
    boxShadow: "none",
    borderRadius: '8px',
    border: '1px solid #d0d0d0',
  },
  aslTableHeader: {
    fontWeight: "bold",
    backgroundColor: "#E5F2F7",
    textAlign: "left",
    padding: "16px",
    borderBottom: "none",
  },
  aslTableCell: {
    textAlign: "left",
    backgroundColor: "#E5F2F7",
    borderBottom: "1px solidrgb(5, 3, 3)",
    padding: "12px 16px",
  },
  // Variant specifically for ASL Details table (header grey, body white)
  aslTableHeaderGrey: {
    fontWeight: "bold",
    backgroundColor: "#E0E0E0",
    textAlign: "left",
    padding: "16px",
    borderBottom: "1px solid #d0d0d0",
   
    '&:last-child': {
      borderRight: "none",
    },
  },
  aslTableCellWhite: {
    textAlign: "left",
    backgroundColor: "#FFFFFF",
    borderBottom: "1px solid #d0d0d0",
    
    padding: "12px 16px",
    '&:last-child': {
      borderRight: "none",
    },
  },
  aslTitle: {
    fontWeight: 700,
    fontSize: '18px',
    marginTop: '24px',
    marginBottom: '16px',
    color: '#000',
  },
  selectedRow: {
    backgroundColor: '#cce5ff',
    '&:hover': {
      backgroundColor: '#b3d9ff',
    },
  },
  fieldValueContainer: {
    marginTop: '24px',
  },
  fieldLabel: {
    fontWeight: 600,
    fontSize: '14px',
    color: '#333',
    marginBottom: '4px',
  },
  fieldValue: {
    fontSize: '14px',
    color: '#666',
    marginBottom: '16px',
    // paddingLeft: '16px',
  },
  fieldValueSection: {
    marginBottom: '24px',
  },
  sectionTitle: {
    fontWeight: 700,
    fontSize: '16px',
    marginBottom: '16px',
    color: '#000',
    borderBottom: '2px solid #E5F2F7',
    paddingBottom: '8px',
  },
  // errorMessage: {
  //   display: 'flex',
  //   alignItems: 'center',
  //   marginTop: '24px',
  //   padding: '16px',
  //   backgroundColor: '#f44336',
  //   borderRadius: '8px',
    
  // },
  expiryErrorMessage: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '24px',
    //padding: '16px',
    // backgroundColor: '#ffebee',
    // borderRadius: '8px',
    // border: '1px solid #f44336',
  },
  warningIcon: {
    color: '#f44336',
    marginRight: '12px',
    fontSize: '28px',
  },
  expiryErrorIcon: {
    color: '#f44336',
    marginRight: '12px',
    fontSize: '28px',
  },
  errorText: {
    fontSize: '16px',
    color: '#f44336',
    fontWeight: 500,
  },
  expiryErrorText: {
    fontSize: '16px',
    color: '#c62828',
    fontWeight: 500,
  },
  borders: {
    border: '2px solid #707070',
    display: 'flex',
    width: '1.6rem',
    backgroundColor: 'grey',
  },
}));

const GenerateGRNDialog = ({ open, onClose, batchData }) => {
  const classes = useStyles();
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [grnApiResponse, setGrnApiResponse] = useState(null);
  const [errorDetails, setErrorDetails] = useState({ errorType: '', errorMessage: '' });
  const [selectedAslNumber, setSelectedAslNumber] = useState('');
  const [aslDetails, setAslDetails] = useState([]);
  const [loadingAslDetails, setLoadingAslDetails] = useState(false);
  const [selectedAslData, setSelectedAslData] = useState(null);
  const [loadingAslData, setLoadingAslData] = useState(false);
  const [loadingBatchDetails, setLoadingBatchDetails] = useState(false);
  const [batchDetailsData, setBatchDetailsData] = useState(null);
  const [grnAslData, setGrnAslData] = useState([]);
  const [loadingGrnAsl, setLoadingGrnAsl] = useState(false);
  const [selectedAslRecord, setSelectedAslRecord] = useState(null);
  const [showFieldValueDialog, setShowFieldValueDialog] = useState(false);
  const [expiryError, setExpiryError] = useState('');
  const [aslTimestamp, setAslTimestamp] = useState('N/A');
  const [aslTransactionID, setAslTransactionID] = useState('N/A');
  const [grnNumber, setGrnNumber] = useState('N/A');
  const aslDetailsRef = useRef(null);
  const reportDialogRef = useRef(null);
  const [isDownloading, setIsDownloading] = useState(false);
  const [aslCheckError, setAslCheckError] = useState('');
  
  // GRN Details state
  const [shippingAllQuantity, setShippingAllQuantity] = useState('Yes');
  const [shipmentRows, setShipmentRows] = useState([{ id: 1, quantity: '' }]);
  const [readyForDispatchQty, setReadyForDispatchQty] = useState(0);
  const [uom, setUom] = useState('');
  const [quantitySumError, setQuantitySumError] = useState('');
  const [showAslSection, setShowAslSection] = useState(false);
  
  // Partial GRN state
  const [qtyAlreadyDispatched, setQtyAlreadyDispatched] = useState(null);
  const [lastShippedDate, setLastShippedDate] = useState(null);
  const [remainingQty, setRemainingQty] = useState(null);
  const [isPartialGRN, setIsPartialGRN] = useState(false);
  const [maxPostingQtyAllowed, setMaxPostingQtyAllowed] = useState(null);
  const [maxPostingQtyUom, setMaxPostingQtyUom] = useState('');

  // Function to extract user information from auth token
  const getUserFromToken = () => {
    const token = localStorage.getItem('authToken');
    if (!token) return null;
    
    try {
      const decoded = jwt_decode(token);
      return {
        fullName: decoded.full_name || decoded.fullName || 'N/A',
      };
    } catch (error) {
      console.error('Error decoding token:', error);
      return null;
    }
  };

  // Get user information from token
  const userInfo = getUserFromToken();

  // Validate shipment quantities sum
  const validateShipmentQuantities = () => {
    // Only include rows that have a valid non-empty value (avoids || 0 coercion)
    const shipmentQuantites = shipmentRows
      .map(row => parseFloat(row.quantity))
      .filter(qty => !isNaN(qty));

    // Check if any filled row has value 0 (only user-typed strings, skip programmatic numbers)
    const hasZeroValue = shipmentRows.some(row => {
      if (typeof row.quantity !== 'string') return false; // skip programmatically set numbers
      if (row.quantity.trim() === '') return false;       // skip empty
      const qty = parseFloat(row.quantity);
      return !isNaN(qty) && qty === 0;
    });

    if (hasZeroValue) {
      setQuantitySumError('You have entered 0 value. Please enter a valid Individual Shipment Quantity.');
      return false;
    }

    const totalShipmentQty = shipmentQuantites.reduce((sum, qty) => sum + qty, 0);
    const qtyToValidate = isPartialGRN ? remainingQty : readyForDispatchQty;
    const isSingleRow = shipmentRows.length === 1;

    // 1st: Validate against readyForDispatchQty / remainingQty
    if (shippingAllQuantity === 'Yes') {
      if (totalShipmentQty !== qtyToValidate) {
        setQuantitySumError(isSingleRow
          ? `Shipment Quantity is not matching ${isPartialGRN ? 'Remaining Qty.' : 'Ready for Dispatch Qty.'}`
          : `Sum of Individual Shipment Quantity is not matching ${isPartialGRN ? 'Remaining Qty.' : 'Ready for Dispatch Qty.'}`);
        return false;
      }
    } else {
      if (totalShipmentQty > qtyToValidate) {
        setQuantitySumError(isSingleRow
          ? `Shipment Quantity cannot exceed ${isPartialGRN ? 'Remaining Qty.' : 'Ready for Dispatch Qty.'}`
          : `Sum of Individual Shipment Quantity cannot exceed ${isPartialGRN ? 'Remaining Qty.' : 'Ready for Dispatch Qty.'}`);
        return false;
      }
    }

    // 2nd: Validate each row against maxPostingQtyAllowed
    if (maxPostingQtyAllowed !== null && maxPostingQtyAllowed !== undefined && maxPostingQtyAllowed > 0) {
      const exceedsMax = shipmentRows.some((row) => {
        const qty = parseFloat(row.quantity);
        return !isNaN(qty) && qty > maxPostingQtyAllowed;
      });
      if (exceedsMax) {
        setQuantitySumError(
          `Individual Shipment Quantity cannot exceed the maximum posting quantity of ${Number(maxPostingQtyAllowed).toLocaleString("en-US")} ${maxPostingQtyUom}.`
        );
        return false;
      }
    }

    setQuantitySumError('');
    return true;
  };

  // Update validation whenever rows change
  useEffect(() => {
    const qtyToCheck = isPartialGRN ? remainingQty : readyForDispatchQty;
    const hasAnyValue = shipmentRows.some(row => row.quantity !== '' && row.quantity !== null && row.quantity !== undefined);
    
    if (qtyToCheck > 0 && shipmentRows.length > 0 && hasAnyValue) {
      validateShipmentQuantities();
    } else if (!hasAnyValue) {
      // Clear error if all fields are empty
      setQuantitySumError('');
    }
  }, [shipmentRows, readyForDispatchQty, remainingQty, isPartialGRN, shippingAllQuantity]);

  // Use batch details data if available, otherwise fall back to static data
  const displayData = batchDetailsData ? {
    cmo: batchDetailsData.cmoMember || batchDetailsData.vendorName || 'N/A',
    cmoIdFromSponsorERP: batchDetailsData.vendorNumber || 'N/A',
    plantId: batchDetailsData.vendorPlant || 'N/A',
    poNumber: batchData?.poNumber || 'N/A',
    productCode: batchDetailsData.fgMaterialCode || batchDetailsData.productCode || 'N/A',
    productDescription: batchDetailsData.fgMaterialName || batchDetailsData.productDescription || 'N/A',
    batchNumber: batchData?.batchNumber || 'N/A',
    dateOfManufacturing: batchDetailsData.manufacturingDate ? new Date(batchDetailsData.manufacturingDate).toLocaleDateString('en-GB') : 'N/A',
    productExpiryDate: batchDetailsData.expiryDate ? new Date(batchDetailsData.expiryDate).toLocaleDateString('en-GB') : 'N/A',
    loggedInUser: userInfo?.fullName || batchDetailsData.loggedInUser || batchDetailsData.userName || 'N/A',
    grnNumber: batchDetailsData.grnNumber || batchDetailsData.grn_number || 'N/A',
    status: batchDetailsData.status || 'N/A',
    message: batchDetailsData.message || 'Ready to generate GRN',
    targetQuantity: batchDetailsData.targetQuantity || 'N/A',
    batchSize: batchDetailsData.batchSize || 'N/A',
    batchUOM: batchDetailsData.batchUOM || 'N/A',
    yield: batchDetailsData.yield || 'N/A',
  } : {
    cmo: 'Loading...',
    cmoIdFromSponsorERP: 'Loading...',
    plantId: 'Loading...',
    poNumber: batchData?.poNumber || 'Loading...',
    productCode: 'Loading...',
    productDescription: 'Loading...',
    batchNumber: batchData?.batchNumber || 'Loading...',
    dateOfManufacturing: 'Loading...',
    productExpiryDate: 'Loading...',
    loggedInUser: userInfo?.fullName || 'Loading...',
    grnNumber: 'Loading...',
    status: 'Loading...',
    message: 'Loading batch details...',
    targetQuantity: 'Loading...',
    batchSize: 'Loading...',
    batchUOM: 'Loading...',
    yield: 'Loading...',
  };

  // Helper function to derive user-friendly error type from error message
  const deriveErrorType = (errorMessage) => {
    if (!errorMessage) return '';
    
    const lowerMessage = errorMessage.toLowerCase();
    
    // Check for storage location errors
    if (lowerMessage.includes('storage location')) {
      return 'Storage location missing';
    }
    
    // Check for quantity exceeded errors
    if (lowerMessage.includes('quantity exceeded')) {
      // Extract the quantity number and format it as XK
      const quantityMatch = errorMessage.match(/exceeded by\s+([\d,]+)/i);
      if (quantityMatch) {
        const quantity = quantityMatch[1].replace(/,/g, '');
        const numericQty = parseInt(quantity);
        if (!isNaN(numericQty)) {
          // Divide by 1,000,000 and floor to get value in millions, display as K
          const qtyInK = Math.floor(numericQty / 1000000);
          return `Quantity exceeded (${qtyInK}K)`;
        }
      }
      return 'Quantity exceeded';
    }
    
    // Check for date parsing errors
    if (lowerMessage.includes('date') && (lowerMessage.includes('parsing') || lowerMessage.includes('unparseable'))) {
      return 'Date parsing error';
    }
    
    return '';
  };

  const handleSubmit = async () => {
    // Validate shipment quantities
    if (!validateShipmentQuantities()) {
      console.error('Sum of shipment quantities must equal ready for dispatch quantity');
      return;
    }

    const shipmentQuantites = shipmentRows.map(row => parseFloat(row.quantity) || 0).filter(q => q > 0);
    
    if (shipmentQuantites.length === 0) {
      console.error('Please enter at least one valid shipment quantity');
      return;
    }

    // Call syncASLDetails API to get ASL data
    if (batchDetailsData) {
      setLoadingGrnAsl(true);
      await fetchSyncASLDetails(batchDetailsData);
      setLoadingGrnAsl(false);
      setShowAslSection(true);
    }
  };

  // Handle final GRN generation with ASL data
  const handleGenerateGRN = async () => {
    if (!selectedAslRecord) {
      console.error('Please select an ASL record from the table');
      return;
    }

    const shipmentQuantites = shipmentRows.map(row => parseFloat(row.quantity) || 0).filter(q => q > 0);

    setIsSubmitting(true);
    
    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/generateGRNFromFE`;
      
      // Format the ASL record with ISO date strings
      const formattedAslRecord = {
        manufacturer: selectedAslRecord.manufacturer,
        mpnMaterial: selectedAslRecord.mpnMaterial,
        recordNumber: selectedAslRecord.recordNumber,
        name: selectedAslRecord.name,
        street: selectedAslRecord.street,
        cityPostalCode: selectedAslRecord.cityPostalCode,
        regionCountry: selectedAslRecord.regionCountry,
        supplyChainStatus: selectedAslRecord.supplyChainStatus,
        validFrom: selectedAslRecord.validFrom ? new Date(selectedAslRecord.validFrom).toISOString() : null,
        validTo: selectedAslRecord.validTo ? new Date(selectedAslRecord.validTo).toISOString() : null,
      };
      
      const payload = {
        cdmoOrgID: batchData?.vendorMosymphonyID,
        schrockenDeliveryScheduleBatchID: batchData?.schrockenDeliveryScheduleBatchID,
        poNumber: displayData.poNumber,
        batchNumber: displayData.batchNumber,
        aslDataList: [formattedAslRecord],
        allQuantitiesShipped: shippingAllQuantity === 'Yes',
        shipmentQuantites: shipmentQuantites,
      };


      const response = await axios.post(url, payload);
      
      if (response.data.success) {
        setGrnApiResponse(response.data);
        setShowSuccessDialog(true);
      } else {
        console.error("GRN generation failed:", response.data);
        
        // Extract error details from the response
        let errorType = '';
        let errorMessage = '';
        
        // Check for new response structure: response.data.sapResponse (array)
        if (response.data.sapResponse && Array.isArray(response.data.sapResponse) && response.data.sapResponse.length > 0) {
          const sapResponse = response.data.sapResponse[0];
          
          // Get error message from sapResponse errors
          if (sapResponse.errors) {
            const errors = sapResponse.errors;
            errorMessage = errors.errorGRN || errors.errorASL || errors.errorQC || errors.errorCC || '';
          }
          
          // Derive user-friendly error type from error message
          errorType = deriveErrorType(errorMessage);
          
          // If no derived error type, use status code
          if (!errorType) {
            if (sapResponse.statusCode) {
              errorType = `Error ${sapResponse.statusCode}`;
              
              // If no specific SAP error message, provide fallback
              if (!errorMessage) {
                const statusCode = sapResponse.statusCode;
                errorMessage = `Bad Request : ${statusCode} : HTTP/1.1 (no specific SAP error)`;
                errorType = `Generic ${statusCode}`;
              }
            }
          }
        }
        // Fallback to old structure: response.data.data.failedShipments
        else if (response.data.data && response.data.data.failedShipments && response.data.data.failedShipments.length > 0) {
          const failedShipment = response.data.data.failedShipments[0];
          
          // Get error message from sapResponse errors
          if (failedShipment.sapResponse && failedShipment.sapResponse.errors) {
            const errors = failedShipment.sapResponse.errors;
            errorMessage = errors.errorGRN || errors.errorASL || errors.errorQC || errors.errorCC || '';
          }
          
          // Derive user-friendly error type from error message
          errorType = deriveErrorType(errorMessage);
          
          // If no derived error type, use status code or error field
          if (!errorType) {
            if (failedShipment.sapResponse && failedShipment.sapResponse.statusCode) {
              errorType = `Error ${failedShipment.sapResponse.statusCode}`;
              
              // If no specific SAP error message, provide fallback
              if (!errorMessage) {
                const statusCode = failedShipment.sapResponse.statusCode;
                errorMessage = `Bad Request : ${statusCode} : HTTP/1.1 (no specific SAP error)`;
                errorType = `Generic ${statusCode}`;
              }
            } else if (failedShipment.error) {
              errorType = failedShipment.error;
            }
          }
        }
        
        setErrorDetails({
          errorType: errorType,
          errorMessage: errorMessage
        });
        setShowErrorDialog(true);
      }
      
    } catch (error) {
      console.error("Error generating GRN:", error);
      
      // Handle network or other errors
      let errorType = '';
      let errorMessage = '';
      
      if (error.response && error.response.data) {
        // Extract error details from error response
        // Check for new response structure: error.response.data.sapResponse (array)
        if (error.response.data.sapResponse && Array.isArray(error.response.data.sapResponse) && error.response.data.sapResponse.length > 0) {
          const sapResponse = error.response.data.sapResponse[0];
          
          // Get error message from sapResponse errors
          if (sapResponse.errors) {
            const errors = sapResponse.errors;
            errorMessage = errors.errorGRN || errors.errorASL || errors.errorQC || errors.errorCC || '';
          }
          
          // Derive user-friendly error type from error message
          errorType = deriveErrorType(errorMessage);
          
          // If no derived error type, use status code
          if (!errorType) {
            if (sapResponse.statusCode) {
              errorType = `Error ${sapResponse.statusCode}`;
              
              // If no specific SAP error message, provide fallback
              if (!errorMessage) {
                const statusCode = sapResponse.statusCode;
                errorMessage = `Bad Request : ${statusCode} : HTTP/1.1 (no specific SAP error)`;
                errorType = `Generic ${statusCode}`;
              }
            }
          }
        }
        // Fallback to old structure: error.response.data.data.failedShipments
        else if (error.response.data.data && error.response.data.data.failedShipments && error.response.data.data.failedShipments.length > 0) {
          const failedShipment = error.response.data.data.failedShipments[0];
          
          // Get error message from sapResponse errors
          if (failedShipment.sapResponse && failedShipment.sapResponse.errors) {
            const errors = failedShipment.sapResponse.errors;
            errorMessage = errors.errorGRN || errors.errorASL || errors.errorQC || errors.errorCC || '';
          }
          
          // Derive user-friendly error type from error message
          errorType = deriveErrorType(errorMessage);
          
          // If no derived error type, use status code or error field
          if (!errorType) {
            if (failedShipment.sapResponse && failedShipment.sapResponse.statusCode) {
              errorType = `Error ${failedShipment.sapResponse.statusCode}`;
              
              // If no specific SAP error message, provide fallback
              if (!errorMessage) {
                const statusCode = failedShipment.sapResponse.statusCode;
                errorMessage = `Bad Request : ${statusCode} : HTTP/1.1 (no specific SAP error)`;
                errorType = `Generic ${statusCode}`;
              }
            } else if (failedShipment.error) {
              errorType = failedShipment.error;
            }
          }
        } else if (error.response.data.message) {
          errorMessage = error.response.data.message;
          errorType = deriveErrorType(errorMessage);
        }
      }
      
      setErrorDetails({
        errorType: errorType,
        errorMessage: errorMessage
      });
      setShowErrorDialog(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSuccessClose = () => {
    setShowSuccessDialog(false);
    onClose(); // Close the main dialog as well
  };

  const handleErrorClose = () => {
    setShowErrorDialog(false);
    setErrorDetails({ errorType: '', errorMessage: '' });
  };

  const handleClickHere = async () => {
    setShowFieldValueDialog(true);
    setShowSuccessDialog(false);
    
    // Call fetchASLDetails to get timestamp and transactionID
    if (batchData?.poNumber && batchData.poNumber !== 'N/A') {
      await fetchASLDetails();
setTimeout(() => {
      handleDownloadReport();
    },1000);
    }
  };

  // Function to download the report as an image
  const handleDownloadReport = async () => {
    if (!reportDialogRef.current) {
      console.error('Report content not available for download');
      return;
    }

    setIsDownloading(true);
    try {
     
      const canvas = await html2canvas(reportDialogRef.current, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: '#ffffff',
      });

     
      canvas.toBlob((blob) => {
        if (blob) {
          // Create download link
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
          const filename = `ASL_Report_${displayData.poNumber}_${displayData.batchNumber}_${timestamp}.png`;
          
          link.href = url;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          
          // Cleanup
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        }
        setIsDownloading(false);
      }, 'image/png');
    } catch (error) {
      console.error('Error downloading report:', error);
      //alert('Failed to download report. Please try again.');
      console.error('Failed to download report. Please try again.');
      setIsDownloading(false);
    }
  };

  // Handle radio selection for ASL records (single selection)
  const handleAslRecordSelect = (record) => {
    setSelectedAslRecord(record);
    
    // Check if validTo date is expired
    if (record.validTo) {
      try {
        const validToDate = new Date(record.validTo);
        const currentDate = new Date();
        // Set time to start of day for accurate comparison
        currentDate.setHours(0, 0, 0, 0);
        validToDate.setHours(0, 0, 0, 0);
        
        if (validToDate < currentDate) {
          setExpiryError('Selected ASL Number Expired. Please update the expiry date in SAP and check again.');
        } else {
          setExpiryError('');
        }
      } catch (error) {
        console.error('Error parsing validTo date:', error);
        setExpiryError('');
      }
    } else {
      setExpiryError('');
    }
  };

  // Check if a record is selected
  const isRecordSelected = (record) => {
    return selectedAslRecord && selectedAslRecord.recordNumber === record.recordNumber;
  };

  // API call to fetch batch details and get comprehensive data
  const fetchBatchDetails = async () => {
    if (!batchData?.schrockenDeliveryScheduleBatchID) {
      console.error("schrockenDeliveryScheduleBatchID is required");
      return;
    }

    setLoadingBatchDetails(true);
    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchDeliveryScheduleBatchDetails`;
      const payload = {
        schrockenDeliveryScheduleBatchID: batchData.schrockenDeliveryScheduleBatchID,
        poNumber: batchData.poNumber,
        batchNumber: batchData.batchNumber,
      };

      const response = await axios.post(url, payload);
      
      if (response.data.status) {
        const data = response.data.data;
        setBatchDetailsData(data);
        // Set maxPostingQtyAllowed only when isActive=true
        if (data?.isActive === true && data?.maxPostingQtyAllowed !== undefined && data?.maxPostingQtyAllowed !== null) {
          setMaxPostingQtyAllowed(data.maxPostingQtyAllowed);
          setMaxPostingQtyUom(data.targetQuantityUOM || data.batchUOM || "");
        }
        return data;
      } else {
        console.error("API returned error status:", response.data);
        return null;
      }
    } catch (error) {
      console.error("Error fetching batch details:", error);
      return null;
    } finally {
      setLoadingBatchDetails(false);
    }
  };

  // Set GRN ASL data from batch details (no longer calling syncASLDetails API)
  const setGrnAslDataFromBatchDetails = (batchDetails, isPartial = false, remainingQuantity = null) => {
    if (!batchDetails) {
      console.error("Batch details are required");
      return;
    }

    // Always set readyForDispatchQty from API response
    setReadyForDispatchQty(batchDetails.readyForDispatchQuantity || 0);
    setUom(batchDetails.batchUOM);
    
    // Initialize first shipment row - don't reset if user has already entered data
    // For non-partial GRN with 'Yes' shipping all, auto-fill with readyForDispatchQuantity
    if (!isPartial && batchDetails.readyForDispatchQuantity) {
      setShipmentRows([{ id: 1, quantity: batchDetails.readyForDispatchQuantity || '' }]);
    }
    // For partial GRN, shipment rows are already set in useEffect based on shippingAllQuantity
    // Don't override them here

    // Check if batch details contain ASL data
    if (batchDetails.grnAsl && batchDetails.grnAsl.length > 0) {
      const aslRecords = batchDetails.grnAsl;
      setGrnAslData(aslRecords);
      setAslCheckError('');
      
      // Auto-select if only one record exists
      if (aslRecords.length === 1) {
        handleAslRecordSelect(aslRecords[0]);
      } else {
        setSelectedAslRecord(null);
        setExpiryError('');
      }
    } else {
      // No ASL data available
      setAslCheckError("No Valid ASL.");
      setGrnAslData([]);
      setSelectedAslRecord(null);
    }
  };

  // API call to sync ASL details
  const fetchSyncASLDetails = async (batchDetails) => {
    if (!batchDetails) {
      console.error("Batch details are required");
      return;
    }

    const fgMaterialCode = batchDetails.fgMaterialCode;
    const vendorNumber = batchDetails.vendorNumber;
    const vendorPlant = batchDetails.vendorPlant;
    const CMO = batchDetails.cmoMember;
    const BMSPONumber = batchDetails.scheduleAgreementNumber;
    const BMSProductDescription = batchDetails.fgMaterialName;
    const BMSProductCode = batchDetails.fgMaterialCode;
    const BMSBatchNumber=batchDetails.vendorBatchNumber;
    

    if (!fgMaterialCode || !vendorNumber || !vendorPlant) {
      console.error("fgMaterialCode, vendorNumber, and vendorPlant are required");
      return;
    }

    setLoadingGrnAsl(true);
    setAslCheckError('');
    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/syncASLDetails`;
      const payload = {
        fgMaterialCode: [fgMaterialCode],
        vendorNumber: [vendorNumber],
        vendorPlant: [vendorPlant],
        CMO: CMO,
        BMSPONumber: BMSPONumber,
        productDescription : BMSProductDescription,
        BMSProductCode: BMSProductCode,
        BMSBatchNumber: BMSBatchNumber,
      };

      const response = await axios.post(url, payload);
      
     
      if (response.status === 503) {
        setAslCheckError("ASL Check in SAP Failed. Please try again.");
        setGrnAslData([]);
        setSelectedAslRecord(null);
        return;
      }
      
      // Check if response message indicates ASL not available
      const responseMessage = response.data?.message || response.data?.result?.message || '';
      if (responseMessage.toLowerCase().includes('asl not available') || 
          responseMessage.toLowerCase().includes('asl not found') ||
          responseMessage.toLowerCase().includes('no valid asl')) {
        setAslCheckError("No Valid ASL.");
        setGrnAslData([]);
        setSelectedAslRecord(null);
        return;
      }
      
      if (response.data.success && response.data.result && response.data.result.grnAsl) {
        const aslRecords = response.data.result.grnAsl;
        
        // Check if ASL array is empty or contains "No Valid ASL" message
        if (aslRecords.length === 0) {
         
          setAslCheckError("No Valid ASL.");
          setGrnAslData([]);
          setSelectedAslRecord(null);
          return;
        }
        
        // Check for "No Valid ASL" or "asl not available" message in the response
        if (aslRecords[0]?.message) {
          const message = aslRecords[0].message.toLowerCase();
          if (message.includes('no valid asl') || 
              message.includes('asl not available') || 
              message.includes('asl not found')) {
            setAslCheckError("No Valid ASL.");
            setGrnAslData([]);
            setSelectedAslRecord(null);
            return;
          }
        }
       
        const hasValidRecords = aslRecords.length > 0 && 
                                aslRecords[0].manufacturer && 
                                !aslRecords[0].message;
        
        if (hasValidRecords) {
          setGrnAslData(aslRecords);
          setAslCheckError(''); // Clear any previous errors
          // Auto-select if only one record exists
          if (aslRecords.length === 1) {
            handleAslRecordSelect(aslRecords[0]);
          } else {
            setSelectedAslRecord(null);
            setExpiryError('');
          }
        } else {
          // Response indicates no ASL data available
          setAslCheckError("No Valid ASL.");
          setGrnAslData([]);
          setSelectedAslRecord(null);
        }
      } else {
        // API returned success: false
        setAslCheckError("No Valid ASL.");
        setGrnAslData([]);
        setSelectedAslRecord(null);
      }
    } catch (error) {
      console.error("Error fetching GRN ASL details:", error);
      
      // Check if error response has status 503
      if (error.response && error.response.status === 503) {
        setAslCheckError("ASL Check in SAP Failed. Please try again.");
      } 
      else if (error.response && error.response.status === 400) {
        // Check if error message indicates ASL not available
        const errorMessage = error.response.data?.message || '';
        if (errorMessage.toLowerCase().includes('asl not available') || 
            errorMessage.toLowerCase().includes('asl not found') ||
            errorMessage.toLowerCase().includes('no valid asl')) {
          setAslCheckError("No Valid ASL.");
        } else {
          setAslCheckError(errorMessage);
        }
      }
      else {
        
        setAslCheckError("ASL Check in SAP Failed. Please try again.");
      }
      
      setGrnAslData([]);
      setSelectedAslRecord(null);
    } finally {
      setLoadingGrnAsl(false);
    }
  };

  // API call to fetch ASL details
  const fetchASLDetails = async () => {
    if (!batchData?.poNumber || batchData.poNumber === 'N/A') {
      console.error('PO Number is required to fetch ASL details');
      return;
    }
    // Check if batchNumber or vendorBatchNumber is available
    const vendorBatchNumber = batchData.vendorBatchNumber || batchData.batchNumber;
    const schrockenDeliveryScheduleBatchID = batchData.schrockenDeliveryScheduleBatchID;
    
    if (!vendorBatchNumber) {
      console.error('Vendor Batch Number is required to fetch ASL details');
      return;
    }
    
   
    setLoadingAslDetails(true);
    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchASLDetails/${batchData.poNumber}/${vendorBatchNumber}/${schrockenDeliveryScheduleBatchID}`;
      const response = await axios.get(url);
      
      if (response.data.success || response.data.status) {
        const responseData = response.data.data;
        
        // Store ASL details in ref for later use
        aslDetailsRef.current = responseData;
        
       
        const grnNumberFromData = responseData.grnNumber || 'N/A';
        setGrnNumber(grnNumberFromData);
        
        // Check if the data contains actual ASL details or just a "not found" message
        if (responseData && responseData.message && responseData.message.includes('not found')) {
          setAslDetails([]);
          setAslTimestamp('N/A');
          setAslTransactionID('N/A');
        } else if (responseData && responseData.aslDataList && responseData.aslDataList.length > 0) {
          // ASL records are in aslDataList array
          const aslRecords = responseData.aslDataList;
          setAslDetails(aslRecords);
          
          let matchingRecord = null;
          
          if (selectedAslRecord) {
            // Find matching record using manufacturer or mpnMaterial
            matchingRecord = aslRecords.find(asl => 
              (asl.manufacturer === selectedAslRecord.manufacturer) || 
              (asl.mpnMaterial === selectedAslRecord.mpnMaterial)
            );
          }
          
          // If no match found but we have records, use the first one
          if (!matchingRecord && aslRecords.length > 0) {
            matchingRecord = aslRecords[0];
          }
          
          if (matchingRecord) {
            // Directly map lastUpdatedDate and transactionID from the matching record
            setAslTimestamp(matchingRecord.lastUpdatedDate || 'N/A');
            setAslTransactionID(matchingRecord.transactionID || 'N/A');
          } else {
            setAslTimestamp('N/A');
            setAslTransactionID('N/A');
          }
        } else {
          setAslDetails([]);
          setAslTimestamp('N/A');
          setAslTransactionID('N/A');
        }
      } else {
        console.error('Failed to fetch ASL details:', response.data);
        setAslDetails([]);
        setAslTimestamp('N/A');
        setAslTransactionID('N/A');
        setGrnNumber('N/A');
      }
    } catch (error) {
      console.error('Error fetching ASL details:', error);
      setAslDetails([]);
      setAslTimestamp('N/A');
      setAslTransactionID('N/A');
      setGrnNumber('N/A');
    } finally {
      setLoadingAslDetails(false);
    }
  };

  // // Fetch detailed ASL data when ASL number is selected
  // const fetchSelectedAslData = async (aslNumber) => {
  //   if (!aslNumber) {
  //     setSelectedAslData(null);
  //     return;
  //   }

  //   setLoadingAslData(true);
  //   try {
  //     const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchASLDetails/${batchData.poNumber}`;
  //     //console.log('Fetching detailed ASL data for:', aslNumber);
  //     const response = await axios.get(url, {
  //       params: {
  //         aslNumber: aslNumber,
  //         poNumber: batchData.poNumber
  //       }
  //     });
  //     //console.log('ASL Details API Response:', response.data);
      
  //     if (response.data.success || response.data.status) {
  //       const aslData = response.data.data;
        
  //       if (aslData && Array.isArray(aslData)) {
  //         // Find the specific ASL data for the selected ASL number
  //         const selectedAsl = aslData.find(asl => 
  //           asl.manufacturer === aslNumber || 
  //           asl.name === aslNumber
  //         );
          
  //         if (selectedAsl) {
  //           setSelectedAslData(selectedAsl);
  //           //console.log('Selected ASL data:', selectedAsl);
  //         } else {
  //           //console.log('ASL data not found for selected ASL number');
  //           setSelectedAslData(null);
  //         }
  //       } else if (aslData && !Array.isArray(aslData)) {
  //         // Single ASL data object
  //         setSelectedAslData(aslData);
  //         //console.log('Selected ASL data (single):', aslData);
  //       } else {
  //         // console.log('No ASL data available');
  //         setSelectedAslData(null);
  //       }
  //     } else {
  //       console.error('Failed to fetch ASL details:', response.data);
  //       setSelectedAslData(null);
  //     }
  //   } catch (error) {
  //     console.error('Error fetching selected ASL data:', error);
  //     setSelectedAslData(null);
  //   } finally {
  //     setLoadingAslData(false);
  //   }
  // };

  // Handle ASL number selection change
  const handleAslNumberChange = (aslNumber) => {
    setSelectedAslNumber(aslNumber);
    if (aslNumber) {
      // fetchSelectedAslData(aslNumber);
    } else {
      setSelectedAslData(null);
    }
  };

  
  React.useEffect(() => {
    if (open && batchData?.schrockenDeliveryScheduleBatchID) {
      // Check if this is a partial GRN scenario (status ID 60)
      const isPartial = batchData?.SASLBatchStatusID === 60 || batchData?.statusDisplayName === 'Partial GRN Generated';
      setIsPartialGRN(isPartial);
      
      // Reset selected record when dialog opens
      setSelectedAslRecord(null);
      setExpiryError('');
      setAslCheckError('');
      
      // Set default shipping quantity based on status
      setShippingAllQuantity(isPartial ? 'No' : 'Yes');
      
      // Initialize shipment rows to empty for both cases
      setShipmentRows([{ id: 1, quantity: '' }]);
      setShowAslSection(false);
      
      // Set partial GRN data if available from batchData
      let remainingQuantity = null;
      if (isPartial && batchData) {
        setQtyAlreadyDispatched(batchData.qtyAlreadyDispatched || null);
        setLastShippedDate(batchData.lastShippedDate || null);
        remainingQuantity = batchData.remainingQtyTobeShipped || batchData.remainingQtyToBeShipped || null;
        setRemainingQty(remainingQuantity);
      } else {
        setQtyAlreadyDispatched(null);
        setLastShippedDate(null);
        setRemainingQty(null);
      }
      
      const fetchData = async () => {
        const batchDetails = await fetchBatchDetails();
        if (batchDetails) {
          // Pass isPartial and remainingQuantity to avoid state timing issues
          setGrnAslDataFromBatchDetails(batchDetails, isPartial, remainingQuantity);
        }
      };
      fetchData();
    }
  }, [open, batchData?.schrockenDeliveryScheduleBatchID, batchData?.poNumber]);
  const convertToLocaleDateTime = (dateTime) => {
    if (!dateTime) return 'N/A';
    try {
      // Handle different date formats
      let date;
      if (typeof dateTime === 'string') {
       
        if (dateTime.includes('T')) {
          // ISO format with time
          date = new Date(dateTime);
        } else {
         
          const parts = dateTime.split(/[-/]/);
          if (parts.length >= 3) {
            // Handle YYYY-MM-DD format
            date = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
          } else {
            date = new Date(dateTime);
          }
        }
      } else {
        date = new Date(dateTime);
      }

      // Check if date is valid
      if (isNaN(date.getTime())) {
        return 'N/A';
      }

      const day = date.getDate();
      const month = date.getMonth(); // 0-11
      const year = date.getFullYear();

      const monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
      
     
      return `${day}-${monthNames[month]}-${year}`;
    } catch (error) {
      console.error('Error formatting date:', error);
      return 'N/A';
    }
  };

  // Format date with time for timestamp display (dd-mon-yyyy HH:MM:SS)
  const formatDateTime = (dateTimeString) => {
    if (!dateTimeString || dateTimeString === 'N/A') return 'N/A';
    try {
      const date = new Date(dateTimeString);
      if (isNaN(date.getTime())) return 'N/A';
      
      const day = String(date.getDate()).padStart(2, '0');
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const month = monthNames[date.getMonth()];
      const year = date.getFullYear();
      
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      
      return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    } catch (error) {
      return dateTimeString;
    }
  };
  return (
    <React.Fragment>
    <Dialog
      open={open && !showSuccessDialog && !showErrorDialog}
      onClose={(event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
          return;
        }
        onClose();
      }}
      fullWidth
      maxWidth="lg"
      PaperProps={{
        sx: {
          borderRadius: 3,
          padding: 3,
          backgroundColor: "#fafafa",
        },
      }}
      style={{ maxHeight: '100vh'}}
    >
      <DialogContent sx={{ overflowY: "auto" }} style={{ position: 'relative', padding: '24px 40px 32px 40px' }}>
        {/* Overall Loading Overlay for Batch Details or ASL Details */}
        {(loadingBatchDetails || loadingGrnAsl) && (
          <Box 
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            display="flex" 
            alignItems="center" 
            justifyContent="center" 
            style={{ 
              backgroundColor: 'rgba(255, 255, 255, 0.95)',
              borderRadius: '8px',
              zIndex: 2000
            }}
          >
            <Box display="flex" flexDirection="column" alignItems="center">
              <CircularProgress size={40} style={{ marginBottom: '16px' }} />
              <Typography>{loadingGrnAsl ? 'Loading ASL details...' : ''}</Typography>
            </Box>
          </Box>
        )}
        <div style={{position: "relative"}}>
          <Grid container justifyContent="flex-end">
          <Typography
            className={classes.closeButton}
            variant="body2"
            onClick={onClose}
            style={{ position: 'absolute', right: 0, top: "0px"}}
          >
            Cancel <CloseIcon style={{ marginLeft: '4px' }} fontSize="large" />
          </Typography>
        </Grid>

        <Typography className={classes.dialogTitle}>
          {showAslSection ? 'ASL Check' : 'Generating GRN'}
        </Typography>
        </div>

        {/* Main Info Table - Updated to match ProductDetailsLoader structure */}
        <Grid
          container
          justifyContent="flex-start"
          style={{ backgroundColor: "#c2e1ef", marginTop: '24px', marginBottom: '24px' }}
        >
          <Grid item>
            <TableContainer
              component={Paper}
              className={classes.tableContainer}
            >
              <Table className={classes.table} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={`${classes.tableCell} ${classes.headerCell}`}
                    >
                      CMO
                    </TableCell>
                    <TableCell
                      className={`${classes.tableCell} ${classes.headerCell}`}
                    >
                      CMO ID from Sponsor ERP
                    </TableCell>
                    <TableCell
                      className={`${classes.tableCell} ${classes.headerCell}`}
                    >
                      Plant ID
                    </TableCell>
                    <TableCell
                      className={`${classes.tableCell} ${classes.headerCell}`}
                    >
                      PO Number
                    </TableCell>
                    <TableCell
                      className={`${classes.tableCell} ${classes.headerCell}`}
                    >
                      Product Code / Description
                    </TableCell>
                    <TableCell
                      className={`${classes.tableCell} ${classes.headerCell}`}
                    >
                      Batch Number
                    </TableCell>
                    <TableCell
                      className={`${classes.tableCell} ${classes.headerCell}`}
                    >
                      Date of Manufacturing
                    </TableCell>
                    <TableCell
                      className={`${classes.tableCell} ${classes.headerCell}`}
                    >
                      Product Expiry Date
                    </TableCell>
                    <TableCell
                      className={`${classes.tableCell} ${classes.headerCell}`}
                    >
                      Logged in user
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell className={classes.tableCell2}>
                      {displayData.cmo}
                    </TableCell>
                    <TableCell className={classes.tableCell2}>
                      {displayData.cmoIdFromSponsorERP}
                    </TableCell>
                    <TableCell className={classes.tableCell2}>
                      {displayData.plantId}
                    </TableCell>
                    <TableCell className={classes.tableCell2}>
                      {displayData.poNumber}
                    </TableCell>
                    <TableCell className={classes.tableCell2}>
                      {displayData.productCode} / {displayData.productDescription}
                    </TableCell>
                    <TableCell className={classes.tableCell2}>
                      {displayData.batchNumber}
                    </TableCell>
                    <TableCell className={classes.tableCell2}>
                      {displayData.dateOfManufacturing}
                    </TableCell>
                    <TableCell className={classes.tableCell2}>
                      {displayData.productExpiryDate}
                    </TableCell>
                    <TableCell className={classes.tableCell2}>
                      {displayData.loggedInUser}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>

        {/* GRN Details Section - Hidden when ASL section is shown */}
        {!showAslSection && (
          <React.Fragment>
        <Typography className={classes.aslTitle} style={{ marginTop: '32px' }}>
          GRN Details
          <span className={classes.borders}></span>
        </Typography>
        
        <Grid container spacing={3} style={{ marginTop: '16px', marginBottom: '24px' }}>
          <Grid item xs={12} md={2}>
            <Typography className={classes.fieldLabel} style={{ fontWeight: 600, fontSize: '14px', marginBottom: '8px' }}>
              Ready for Dispatch Qty.
            </Typography>
            <Typography style={{ fontSize: '16px', color: '#333' }}>
            {readyForDispatchQty !== null && readyForDispatchQty !== undefined && Number.isFinite(parseFloat(readyForDispatchQty)) ? parseFloat(readyForDispatchQty).toFixed(3) : 'N/A'}
            </Typography>
          </Grid>
          
          {/* Partial GRN Info - Show only when status is Partial GRN Generated */}
          {isPartialGRN && (
            <>
              <Grid item xs={12} md={2}>
                <Typography className={classes.fieldLabel} style={{ fontWeight: 600, fontSize: '14px', marginBottom: '8px' }}>
                  Qty. already dispatched
                </Typography>
                <Typography style={{ fontSize: '16px', color: '#333' }}>
                {qtyAlreadyDispatched !== null && qtyAlreadyDispatched !== undefined && Number.isFinite(parseFloat(qtyAlreadyDispatched)) ? parseFloat(qtyAlreadyDispatched).toFixed(3) : 'N/A'}
                </Typography>
              </Grid>
              <Grid item xs={12} md={2}>
                <Typography className={classes.fieldLabel} style={{ fontWeight: 600, fontSize: '14px', marginBottom: '8px' }}>
                  Last shipped at
                </Typography>
                <Typography style={{ fontSize: '16px', color: '#333' }}>
                  {lastShippedDate ? new Date(lastShippedDate).toLocaleString('en-GB', {
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                    hour12: false
                  }).replace(/,/g, '').toUpperCase() : 'N/A'}
                </Typography>
              </Grid>
              <Grid item xs={12} md={2}>
                <Typography className={classes.fieldLabel} style={{ fontWeight: 600, fontSize: '14px', marginBottom: '8px' }}>
                  Remaining Qty.
                </Typography>
                <Typography style={{ fontSize: '16px', color: '#333' }}>
                {remainingQty !== null && remainingQty !== undefined && Number.isFinite(parseFloat(remainingQty)) ? parseFloat(remainingQty).toFixed(3) : 'N/A'}
                </Typography>
              </Grid>
            </>
          )}
          
          <Grid item xs={12} md={1}>
            <Typography className={classes.fieldLabel} style={{ fontWeight: 600, fontSize: '14px', marginBottom: '8px' }}>
              UoM
            </Typography>
            <Typography style={{ fontSize: '16px', color: '#333' }}>
              {uom}
            </Typography>
          </Grid>
          <Grid item xs={12} md={3}>
            <Typography className={classes.fieldLabel} style={{ fontWeight: 600, fontSize: '14px', marginBottom: '8px' }}>
              Shipping all {isPartialGRN ? 'remaining' : ''} quantity
            </Typography>
            <FormControl 
              variant="outlined" 
              size="small" 
              fullWidth 
              className={classes.selectField}
              // style={isPartialGRN ? { 
              //   border: '2px solid #d32f2f',
              //   borderRadius: '4px'
              // } : {}}
            >
              <Select
                value={shippingAllQuantity}
                onChange={(e) => {
                  setShippingAllQuantity(e.target.value);
                  if (e.target.value === 'Yes') {
                    // For partial GRN, use remainingQty; otherwise use readyForDispatchQty
                    const qtyToUse = isPartialGRN ? remainingQty : readyForDispatchQty;
                    setShipmentRows([{ id: 1, quantity: qtyToUse || '' }]);
                  } else {
                    setShipmentRows([{ id: 1, quantity: '' }]);
                  }
                }}
              >
                <MenuItem value="Yes">Yes</MenuItem>
                <MenuItem value="No">No</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        {/* Shipment Quantities Table */}
        {!loadingGrnAsl && 
          <Grid item xs={12}>
            <TableContainer style={{maxWidth: "660px"}} component={Paper} className={classes.aslTableContainer}>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.aslTableHeaderGrey}>GRN Serial Number</TableCell>
                    <TableCell className={classes.aslTableHeaderGrey}>Individual Shipment Quantity</TableCell>
                    <TableCell className={classes.aslTableHeaderGrey}>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {shipmentRows.map((row, index) => (
                    <TableRow key={row.id}>
                      <TableCell className={classes.aslTableCellWhite}>{index + 1}</TableCell>
                      <TableCell className={classes.aslTableCellWhite}>
                        <TextField
                          type="number"
                          variant="outlined"
                          size="small"
                          value={row.quantity}
                          onChange={(e) => {
                            const newRows = [...shipmentRows];
                            newRows[index].quantity = e.target.value;
                            setShipmentRows(newRows);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === '+' || e.key === '-' || e.key === 'e' || e.key === 'E') {
                              e.preventDefault();
                            }
                          }}
                          fullWidth
                          inputProps={{ min: 0, step: "any" }}
                        />
                      </TableCell>
                      <TableCell className={classes.aslTableCellWhite}>
                        {index > 0 && (
                          <IconButton
                            onClick={() => {
                              setShipmentRows(shipmentRows.filter(r => r.id !== row.id));
                            }}
                            size="small"
                          >
                            <DeleteIcon color="error" />
                          </IconButton>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
        </Grid>}

        {/* Notes */}
        <Grid container style={{ marginTop: '16px', marginBottom: '16px' }}>
          <Grid item xs={12}>
            <Typography variant="body2" style={{ fontSize: '12px', color: '#666' }}>
              Note 1 - If Shipping all {`${isPartialGRN ? 'remaining' : ''}`} quantity = YES, sum of all Individual Shipment Size should match {`${isPartialGRN ? 'Remaining Qty.' : 'Ready for Dispatch Qty.'}`}
            </Typography>
            <Typography variant="body2" style={{ fontSize: '12px', color: '#666' }}>
              Note 2 - Consumed batch quantity is assigned proportionately to each GRN Serial Number, based on the Individual Shipment Size.
            </Typography>
            {
            maxPostingQtyAllowed !== null && maxPostingQtyAllowed !== undefined &&maxPostingQtyAllowed > 0 && (
              <Typography variant="body2" style={{ fontSize: '12px', color: '#666' }}>
                Note 3 - Under shipment configuration, this Product is allowed maximum posting quantity of {Number(maxPostingQtyAllowed).toLocaleString("en-US")} {maxPostingQtyUom} only.
              </Typography>
            )}
          </Grid>
        </Grid>

        {/* Add New Row Button */}
        <Grid container style={{ marginBottom: '24px' }}>
          <Grid item>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => {
                const newId = Math.max(...shipmentRows.map(r => r.id), 0) + 1;
                setShipmentRows([...shipmentRows, { id: newId, quantity: '' }]);
              }}
              disabled = {loadingGrnAsl}
              startIcon={<AddCircleOutlineIcon style={{ fontSize: 21 }} />}
              style={{
                fontSize: "14px",
                minWidth: "162px",
                height: "40px",
                padding: "5px 12px",
                borderColor: "#000000",
                color: "#000000",
                fontWeight: "600",
                borderRadius: "20px"
              }}
            >
              Add New Row
            </Button>
          </Grid>
        </Grid>

        {/* Validation Error for Quantity Sum */}
        {quantitySumError && (
          <Box style={{
            border: '1px solid #f44336',
            backgroundColor: '#ffebee',
            color: '#d32f2f',
            display: 'flex',
            alignItems: 'center',
            padding: '12px 16px',
            borderRadius: '8px',
            marginBottom: '24px',
          }}>
            <WarningIcon style={{ color: '#f44336', marginRight: '12px', fontSize: '24px' }} />
            <Typography style={{ fontSize: '14px', fontWeight: 500 }}>
              {quantitySumError}
            </Typography>
          </Box>
        )}
          </React.Fragment>
        )}

        {/* ASL Details Section - Only shown after Confirm Submission */}
        {showAslSection && (
          <React.Fragment>
            <Typography className={classes.aslTitle} style={{ marginTop: '32px' }}>
              ASL Details
              <span className={classes.borders}></span>
            </Typography>
            
            {/* Loading indicator for GRN ASL */}
            {loadingGrnAsl && (
              <Box display="flex" justifyContent="center" alignItems="center" style={{ marginTop: '24px', marginBottom: '16px' }}>
                <CircularProgress size={24} />
                <Typography variant="body2" style={{ marginLeft: '16px' }}>
                  Loading ASL details...
                </Typography>
              </Box>
            )}

            {/* ASL Table */}
            {!loadingGrnAsl && grnAslData.length > 0 && (
              <Grid container style={{ marginTop: '20px', marginBottom: '24px' }}>
                <Grid item xs={12}>
                  <TableContainer component={Paper} className={classes.aslTableContainer}>
                    <Table className={classes.table} aria-label="grn asl table">
                      <TableHead>
                        <TableRow>
                          <TableCell className={classes.aslTableHeaderGrey}>Select</TableCell>
                          <TableCell className={classes.aslTableHeaderGrey}>ASL Number (Manufacturer)</TableCell>
                          <TableCell className={classes.aslTableHeaderGrey}>MPN Number</TableCell>
                          <TableCell className={classes.aslTableHeaderGrey}>Name</TableCell>
                          <TableCell className={classes.aslTableHeaderGrey}>Street</TableCell>
                          <TableCell className={classes.aslTableHeaderGrey}>City And Postal Code</TableCell>
                          <TableCell className={classes.aslTableHeaderGrey}>Region And Country</TableCell>
                          <TableCell className={classes.aslTableHeaderGrey}>Supply Chain Status And Country</TableCell>
                          <TableCell className={classes.aslTableHeaderGrey}>Expiry Date</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {grnAslData.map((row, index) => (
                          <TableRow 
                            key={index}
                            className={isRecordSelected(row) ? classes.selectedRow : ''}
                          >
                            <TableCell className={classes.aslTableCellWhite}>
                              <Radio
                                checked={isRecordSelected(row)}
                                onChange={() => handleAslRecordSelect(row)}
                                color="primary"
                              />
                            </TableCell>
                            <TableCell className={classes.aslTableCellWhite}>
                              {row.manufacturer || 'N/A'}
                            </TableCell>
                            <TableCell className={classes.aslTableCellWhite}>
                              {row.mpnMaterial || 'N/A'}
                            </TableCell>
                            <TableCell className={classes.aslTableCellWhite}>
                              {row.name || 'N/A'}
                            </TableCell>
                            <TableCell className={classes.aslTableCellWhite}>
                              {row.street || 'N/A'}
                            </TableCell>
                            <TableCell className={classes.aslTableCellWhite}>
                              {row.cityPostalCode || 'N/A'}
                            </TableCell>
                            <TableCell className={classes.aslTableCellWhite}>
                              {row.regionCountry || 'N/A'}
                            </TableCell>
                            <TableCell className={classes.aslTableCellWhite}>
                              {row.supplyChainStatus || 'N/A'}
                            </TableCell>
                            <TableCell className={classes.aslTableCellWhite}>
                              {convertToLocaleDateTime(row.validTo) || 'N/A'}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              </Grid>
            )}

            {/* Error message when ASL check fails */}
            {!loadingGrnAsl && aslCheckError && (
              <Box style={{
                border: '1px solid #f44336',
                backgroundColor: '#ffebee',
                color: '#d32f2f',
                display: 'flex',
                alignItems: 'center',
                padding: '12px 16px',
                borderRadius: '8px',
                marginTop: '24px',
                marginBottom: '16px',
              }}>
                <WarningIcon style={{ color: '#f44336', marginRight: '12px', fontSize: '24px' }} />
                <Typography style={{ fontSize: '14px', fontWeight: 500 }}>
                  {aslCheckError}
                </Typography>
              </Box>
            )}

            {/* Expiry Error message */}
            {expiryError && (
              <Box style={{
                border: '1px solid #f44336',
                backgroundColor: '#ffebee',
                color: '#d32f2f',
                display: 'flex',
                alignItems: 'center',
                padding: '12px 16px',
                borderRadius: '8px',
                marginTop: '24px',
                marginBottom: '16px',
              }}>
                <WarningIcon style={{ color: '#f44336', marginRight: '12px', fontSize: '24px' }} />
                <Typography style={{ fontSize: '14px', fontWeight: 500 }}>
                  {expiryError}
                </Typography>
              </Box>
            )}
          </React.Fragment>
        )}


      </DialogContent>
      
      <DialogActions style={{ justifyContent: 'center', paddingTop: '24px', paddingBottom: '24px', paddingLeft: '40px', paddingRight: '40px' }}>
        {!showAslSection ? (
          <Button
            variant="contained"
            className={classes.submitButton}
            onClick={handleSubmit}
            disabled={
              isSubmitting || 
              loadingGrnAsl ||
              !!quantitySumError || 
              !shipmentRows.every(row => parseFloat(row.quantity) > 0)
            }
            startIcon={isSubmitting || loadingGrnAsl ? <CircularProgress size={20} color="inherit" /> : null}
          >
            {loadingGrnAsl ? 'Loading ASL details...' : 'Confirm Submission'}
          </Button>
        ) : (
          <Button
            variant="contained"
            className={classes.submitButton}
            onClick={handleGenerateGRN}
            disabled={isSubmitting || !selectedAslRecord || !!expiryError || !!aslCheckError}
            startIcon={isSubmitting ? <CircularProgress size={20} color="inherit" /> : null}
          >
            {isSubmitting ? 'Generating GRN...' : 'Submit ASL Information to SAP and Generate GRN'}
          </Button>
        )}
      </DialogActions>
    </Dialog>

    {/* Success Dialog */}
    <Dialog
      open={showSuccessDialog}
      onClose={(event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
          return;
        }
        handleSuccessClose();
      }}
      maxWidth="sm"
      fullWidth
      aria-labelledby="success-dialog"
    >
      <DialogContent className={classes.successDialog}>
        <CheckCircleIcon className={classes.successIcon} />
        
        <Typography className={classes.successTitle}>
          ASL - GRN Details submitted successfully
        </Typography>
        
        
        
        <Typography className={classes.successMessage}>
          Image of ASL Check proof has been sent to your email.
        </Typography>
        
        <Typography className={classes.successMessage}>
          <span 
            className={classes.clickHereLink}
            onClick={handleClickHere}
          >
            Click here
          </span>{' '}
          to download the image.
        </Typography>

       
        
        <Button
          variant="contained"
          className={classes.okButton}
          onClick={handleSuccessClose}
          endIcon={<ChevronRightIcon />}
        >
          OK
        </Button>
      </DialogContent>
    </Dialog>

    {/* Error Dialog */}
    <Dialog
      open={showErrorDialog}
      onClose={(event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
          return;
        }
        handleErrorClose();
      }}
      maxWidth="sm"
      fullWidth
      aria-labelledby="error-dialog"
    >
      <DialogContent className={classes.errorDialog}>
        <Box display="flex" justifyContent="center">
          <WarningIcon className={classes.errorIcon} />
        </Box>
        
        <Typography className={classes.errorTitle} style={{ textAlign: 'center' }}>
          GRN generation failed
        </Typography>
        
        <Typography className={classes.errorMessage} style={{ textAlign: 'left', marginTop: '16px' }}>
          There was some error in GRN Details submission. Please try again later.
        </Typography>
        
        <ul style={{ textAlign: 'left', marginTop: '12px', paddingLeft: '20px', listStyleType: 'disc' }}>
          {/* {errorDetails.errorType && (
            <li style={{ marginBottom: '8px' }}>
              <Typography component="span" style={{ fontSize: '1rem' }}>
                Error type as received - {errorDetails.errorType}
              </Typography>
            </li>
          )} */}
          
          {errorDetails.errorMessage && (
            <li style={{ marginBottom: '8px' }}>
              <Typography component="span" style={{ fontSize: '1rem' }}>
                Error message as received - {errorDetails.errorMessage}
              </Typography>
            </li>
          )}
        </ul>
        
        <Typography className={classes.errorMessage} style={{ textAlign: 'left', marginTop: '12px' }}>
          Jira link for issue - <a href="https://collabrix-jsm.atlassian.net/servicedesk/customer/portal/1/group/34/create/67" target="_blank" rel="noopener noreferrer">https://collabrix-jsm.atlassian.net/servicedesk/customer/portal/1/group/34/create/67</a>
        </Typography>
        
        <Box display="flex" justifyContent="center" marginTop="16px">
          <Button
            variant="contained"
            className={classes.okButton}
            onClick={handleErrorClose}
            endIcon={<ChevronRightIcon />}
          >
            OK
          </Button>
        </Box>
      </DialogContent>
    </Dialog>

    {/* Field-Value Dialog */}
    <Dialog
      open={showFieldValueDialog}
      onClose={(event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
          return;
        }
        setShowFieldValueDialog(false);
        setShowSuccessDialog(false);
        onClose();
      }}
      fullWidth
      maxWidth="lg"
      style={{ maxHeight: '90vh' }}
    >
      <DialogContent style={{ position: 'relative', padding: '24px 40px 32px 40px' }}>
      
        {/* Loading Overlay for ASL Details */}
        {loadingAslDetails && (
          <Box 
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            display="flex" 
            alignItems="center" 
            justifyContent="center" 
            style={{ 
              backgroundColor: 'rgba(255, 255, 255, 0.95)',
              borderRadius: '8px',
              zIndex: 2000
            }}
          >
            <Box display="flex" flexDirection="column" alignItems="center">
              <CircularProgress size={40} style={{ marginBottom: '16px' }} />
              <Typography>Loading ASL details...</Typography>
            </Box>
          </Box>
        )}
        
        <Grid container justifyContent="flex-end" style={{ marginBottom: '16px' }}>
          <Typography
            className={classes.closeButton}
            variant="body2"
            onClick={() => {
              setShowFieldValueDialog(false);
              setShowSuccessDialog(false);
              onClose();
            }}
          >
            Cancel <CloseIcon style={{ marginLeft: '4px' }} fontSize="large" />
          </Typography>
        </Grid>
        <div ref={reportDialogRef}>

        <Typography className={classes.dialogTitle}>
          Reports of ASL - GRN Check During generation of GRN
        </Typography>
        <Typography style={{
    fontSize: '22px',
    marginBottom: '1.5rem',
    textAlign: 'center',
    color: '#000', }}>
          Document with GRN Number<br/> {grnNumber ? grnNumber.replace(/,/g, ', ') : 'N/A'} posted successfully
        </Typography>


        {/* Batch Details - Ribbon Table (same as main) */}
        <Grid
          container
          justifyContent="flex-start"
          style={{ backgroundColor: "#c2e1ef", marginTop: '24px', marginBottom: '24px' }}
        >
          <Grid item>
            <TableContainer
              component={Paper}
              className={classes.tableContainer}
            >
              <Table className={classes.table} aria-label="batch details ribbon">
                <TableHead>
                  <TableRow>
                    <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>
                      CMO
                    </TableCell>
                    <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>
                      CMO ID from Sponsor ERP
                    </TableCell>
                    <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>
                      Plant ID
                    </TableCell>
                    <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>
                      PO Number
                    </TableCell>
                    <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>
                      Product Code / Description
                    </TableCell>
                    <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>
                      Batch Number
                    </TableCell>
                    <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>
                      Date of Manufacturing
                    </TableCell>
                    <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>
                      Product Expiry Date
                    </TableCell>
                    <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>
                      Logged in user
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell className={classes.tableCell2}>
                      {displayData.cmo}
                    </TableCell>
                    <TableCell className={classes.tableCell2}>
                      {displayData.cmoIdFromSponsorERP}
                    </TableCell>
                    <TableCell className={classes.tableCell2}>
                      {displayData.plantId}
                    </TableCell>
                    <TableCell className={classes.tableCell2}>
                      {displayData.poNumber}
                    </TableCell>
                    <TableCell className={classes.tableCell2}>
                      {displayData.productCode} / {displayData.productDescription}
                    </TableCell>
                    <TableCell className={classes.tableCell2}>
                      {displayData.batchNumber}
                    </TableCell>
                    <TableCell className={classes.tableCell2}>
                      {displayData.dateOfManufacturing}
                    </TableCell>
                    <TableCell className={classes.tableCell2}>
                      {displayData.productExpiryDate}
                    </TableCell>
                    <TableCell className={classes.tableCell2}>
                      {displayData.loggedInUser}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>

        {/* GRN ASL Details Section */}
        {selectedAslRecord && (
          <div className={classes.fieldValueSection}>
            <Typography className={classes.sectionTitle} style={{ marginTop: '24px' }}>
             ASL Details
              <span className={classes.borders}></span>
            </Typography>
            <div style={{ marginBottom: '24px', padding: '16px'}}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <Typography className={classes.fieldLabel}>MPN Material</Typography>
                  <Typography className={classes.fieldValue}>{selectedAslRecord.mpnMaterial || 'N/A'}</Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography className={classes.fieldLabel}>Street</Typography>
                  <Typography className={classes.fieldValue}>{selectedAslRecord.street || 'N/A'}</Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography className={classes.fieldLabel}>Name</Typography>
                  <Typography className={classes.fieldValue}>{selectedAslRecord.name || 'N/A'}</Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography className={classes.fieldLabel}>City Postal Code</Typography>
                  <Typography className={classes.fieldValue}>{selectedAslRecord.cityPostalCode || 'N/A'}</Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography className={classes.fieldLabel}>Supply Chain Status</Typography>
                  <Typography className={classes.fieldValue}>{selectedAslRecord.supplyChainStatus || 'N/A'}</Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography className={classes.fieldLabel}>Region Country</Typography>
                  <Typography className={classes.fieldValue}>{selectedAslRecord.regionCountry || 'N/A'}</Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography className={classes.fieldLabel}>Manufacturer</Typography>
                  <Typography className={classes.fieldValue}>{selectedAslRecord.manufacturer || 'N/A'}</Typography>
                </Grid>
                {/* <Grid item xs={12} md={4}>
                  <Typography className={classes.fieldLabel}>Valid From</Typography>
                  <Typography className={classes.fieldValue}>{selectedAslRecord.validFrom || 'N/A'}</Typography>
                </Grid> */}
                <Grid item xs={12} md={4}>
                  <Typography className={classes.fieldLabel}>Expiry Date</Typography>
                  <Typography className={classes.fieldValue}>{selectedAslRecord.validTo || 'N/A'}</Typography>
                </Grid>

                <Grid item xs={12} md={4}>
                  <Typography className={classes.fieldLabel}>TimeStamp of ASL Submission in to SAP</Typography>
                  <Typography className={classes.fieldValue}>{formatDateTime(aslTimestamp)}</Typography>
                </Grid>

                <Grid item xs={12} md={4}>
                  <Typography className={classes.fieldLabel}>Transaction ID of ASL Submission in to SAP</Typography>
                  <Typography className={classes.fieldValue}>{aslTransactionID}</Typography>
                </Grid>

              </Grid>
            </div>
          </div>
        )}
        </div>

        <DialogActions style={{ justifyContent: 'center', paddingTop: '24px', paddingBottom: '24px', paddingLeft: '40px', paddingRight: '40px' }}>
          <Button
            variant="contained"
            className={classes.okButton}
            onClick={() => {
              setShowFieldValueDialog(false);
              setShowSuccessDialog(false);
              onClose();
            }}
            endIcon={<ChevronRightIcon />}
          >
            Close
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
    </React.Fragment>
  );
};

export default GenerateGRNDialog;